import React from 'react';
import './factsLanding.style.css';
import IncomemaxLogo from "../../images/edf-logo.svg"

const FactsLanding = () => {

    return (
        <div id="facts" className="facts-landing-body">
            <h3>Who is IncomeMax?</h3>
            <p>IncomeMax is a social enterprise that has been employed by EDF Energy to make sure the Warm Home Discount is given to the people who need it.</p>
            <img src={IncomemaxLogo}/> 

        </div>
    )
}

export default FactsLanding;